<template>
  <div
    :aria-expanded="isOpen"
    class="dropdown-header"
    :class="{ 'dropdown-header-expanded': isOpen }"
    role="button"
    tabindex="0"
    @click="onClick()"
    @keydown.enter="onClick()"
    @keydown.space="(event: Event) => onClick(event, true)"
  >
    <div class="dropdown-header-content">
      <div class="header">{{ title }}</div>
      <div :class="{ rotated: isOpen }">
        <img src="@/assets/drop-down-arrow.svg" alt="Dropdown arrow" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue'
interface Props {
  title: string
  isOpen: boolean
}
const props = defineProps<Props>()
const emits = defineEmits<{ (e: 'toggle'): void }>()
const { title, isOpen } = toRefs(props)
const onClick = (event?: Event, preventDefault?: boolean) => {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emits('toggle')
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';
.dropdown-header {
  border-radius: variables.$border-radius-medium;
  position: relative;
  padding: 10px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  background-color: variables.$color-grey-blue-dark;
  color: variables.$color-text-white-70;
  cursor: pointer;
  font-weight: 600;
  &-expanded {
    border-radius: variables.$border-radius-medium variables.$border-radius-medium 0 0;
  }
}
.dropdown-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
}
.rotated {
  transform: rotate(-180deg);
}
</style>
